import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8 7.47C8.798 5.825 9.915 5 11.99 5s3.831 1.647 3.99 3.294c.154 1.58-.607 3.099-2.186 4.005-.704.404-1.804 1.378-1.804 2.583m0 4.118v-.017"
    })
  ]))
}